import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=486b60b0&scoped=true"
import script from "./Ticket.vue?vue&type=script&lang=js"
export * from "./Ticket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b60b0",
  null
  
)

export default component.exports